import { JackInTheBox, Fade } from "react-awesome-reveal";
import seroujIcon from '../assets/images/seroujkhandjihanian.webp';
import AboutSectionCard from '../components/AboutSectionCard';
import SideAreaTitle from '../components/SideAreaTitle';
import type { AboutSectionCardItem } from '../store/types';

const workExperienceItems: AboutSectionCardItem[] = [
    {
        title: "Senior App Developer",
        subtitle: "ITXI | OCT 2021 - present",
        list: [
            {
                title: "Experience",
                items: [
                    "Design, develop, and maintain high-quality mobile applications",
                    "Implement automated testing solutions and write end-to-end testing scripts",
                    "Collaborate with cross-functional teams to ensure performance, scalability, and reliability"
                ]
            },
            {
                title: "Technologies",
                items: [
                    "React Native CLI, Detox (E2E Testing), React Native Testing Library, Firebase, SonarCloud, Atlassian tools"
                ]
            }
        ]
    },
    {
        title: "Senior Full Stack Developer:",
        subtitle: "Hellotree Digital | May 2020 - August 2021 (15 months)",
        list: [
            {
                title: "Experience",
                items: [
                    "Developed and deployed full-stack web applications across various industries",
                    "Managed ongoing maintenance, updates, and performance optimization for client websites",
                    "Delivered responsive, user-focused interfaces with scalable backend solutions"
                ]
            },
            {
                title: "Technologies",
                items: [
                    "HTML, SCSS, JavaScript, jQuery, Bootstrap, Laravel, React.js, React Three Fiber, WordPress"
                ]
            }
        ]
    },
    {
        title: "Junior Web Developer:",
        subtitle: "EXODES DESIGN | May 2019 - May 2020",
        list: [
            {
                items: [
                    "Assisted in the development and customization of websites",
                    "Collaborated with designers and developers to deliver functional and visually appealing solutions"
                ]
            }
        ]
    },
    {
        title: "Private Guitar Instructor :",
        subtitle: "| 2014 - 2018",
        list: [
            {
                items: [
                    "Taught 25+ students, tailoring lessons to different skill levels and learning styles"
                ]
            }
        ]
    },
    {
        title: "Private Math and Physics Instructor  :",
        subtitle: "12+ Students (2018-2020)",
        list: [
            {
                items: [
                    "Provided one-on-one tutoring to 12+ students for scientific subjects, improving academic performance and understanding of core concepts"
                ]
            }
        ]
    }
];

const certificateItems: AboutSectionCardItem[] = [
    {
        title: "7th Place – Build Outside the Box Hardware Hackathon (50 Teams)",
        subtitle: "IEEE AUB Student Branch (1-2-2019)",
    },
    {
        title: "1st Place – Arduino Competition",
        subtitle: "IEEE Lebanese University (15-3-2019)",
    },
    {
        title: "College-wide Award for Excellence in Scientific Subjects",
        subtitle: "(4-7-2017)",
    },
    {
        title: "College-wide Outstanding Student Award",
        subtitle: "(1-7-2016)",
    },

    {
        title: "Exemplary Scout Award",
        subtitle: "(28-8-2018)",
        list: []
    },
    {
        title: "Several Leadership Certificates",
    },
];

const interestItems: AboutSectionCardItem[] = [
    {
        title: "Chess, Hiking, Guitar & Reading",
    },
    {
        title: "Professional Road Cyclist",
        subtitle: "(2015-2018)",
    },
    {
        title: "Chief Scouts",
        subtitle: "Years of Leadership & Service",
    },
    {
        title: "Mountaineering – Summit of Mount Ararat (5,137m)",
        subtitle: "2-8 August 2023",
    },
];


const About = () => {
    return (
        <section className="col-lg-9 col-xl-7 fh-100 side-area-container" aria-labelledby="about-page-title">
            <div className="white_box"></div>
            <section className="box_container w-100  pos-z red " aria-labelledby="about-page-title">
                <SideAreaTitle id="about-page-title" title="About" colorClass="red" />

                <div className="row align-items-center justify-content-center">
                    <div className="col-lg-4 col-md-4">
                        <JackInTheBox delay={150}>
                            <div className="round_image_circle ">
                                <img src={seroujIcon} className='padding_img grayscale' alt="Serouj Khanjihanian" />
                            </div>
                        </JackInTheBox>
                    </div>

                    <section className="col-lg-8 col-md-8" aria-labelledby="about-profile-heading">
                        <Fade triggerOnce delay={120}  >
                            <h2 id="about-profile-heading" className="fs-25 mb-4 mt-lg-0 mt-4">
                                <span className="border-bottom red  pb-1 fw-800">Serouj Khandjihanian</span>
                            </h2>
                            <p><span className="fw-800">Occupation &nbsp;:</span> Software Developer</p>
                            <p><span className="fw-800">Nationality &nbsp;:</span> Lebanese</p>
                            <p><span className="fw-800">Birthdate &nbsp;:</span> 28/05/2000</p>
                            <p><span className="fw-800">Country &nbsp;:</span> Lebanon</p>
                            <p><span className="fw-800">Email &nbsp;:</span> <a href="mailto:seroujkh@hotmail.com" rel="noreferrer" target="_blank" className="link_red">seroujkh@hotmail.com</a></p>
                            <p><span className="fw-800">TEl &nbsp;:</span> <a href="tel:+96171032898" rel="noreferrer" target="_blank" className="link_red">+961 71 032898</a></p>

                            <p><span className="fw-800">Languages &nbsp;:</span> English | Arabic | Armenian</p>
                        </Fade>
                    </section>
                </div>

                <div className="row justify-content-center">

                    <section className="col-12 pb-5" aria-label="About details">
                        <Fade triggerOnce delay={100} >
                            <section className="bg-light border-radius-25 p-4  mt-3" aria-labelledby="about-objective-heading">
                                <h2 id="about-objective-heading" className="fs-25 mb-4 text-red">
                                    <span className="border-bottom black   pb-1 fw-700">MY OBJECTIVE</span>
                                </h2>
                                <p className="fw-600">Dedicated and results-driven professional with a strong work ethic, collaborative mindset, and demonstrated leadership skills. Committed to continuous growth and self-improvement, I actively seek opportunities to expand my expertise. I am motivated to take on new challenges and contribute meaningfully to the success of innovative, forward-thinking organizations.</p>
                            </section>
                        </Fade>
                        <Fade triggerOnce delay={100} >
                            <section className="bg-light border-radius-25 p-4  mt-3" aria-labelledby="about-education-heading">
                                <h2 id="about-education-heading" className="fs-25 mb-4 text-red">
                                    <span className="border-bottom black   pb-1 fw-700">EDUCATION</span>
                                </h2>

                                <ul className="fw-600 list-unstyled mb-0">
                                    <li>
                                        <span className="text-red "> <b>- </b></span>
                                        <span className="fw-700">BS in Computer Science (2018-2021) :</span> Lebanese University
                                    </li>
                                    <li>
                                        <span className="text-red "> <b>- </b></span>
                                        <span className="fw-700">General Science College Degree (2018) :</span> Yeghishe Manoukian College
                                    </li>
                                    <li>
                                        <span className="text-red "> <b>- </b></span>
                                        <span className="fw-700">Classical Guitar Level 7 Degree (2009-2020) :</span> Parsegh Ganatchian Music School, Lebanon-Armenia
                                    </li>
                                </ul>
                            </section>
                        </Fade>
                        <AboutSectionCard items={workExperienceItems} title="WORK EXPERIENCE" />
                        <AboutSectionCard items={certificateItems} title="CERTIFICATES" />
                        <AboutSectionCard items={interestItems} title="INTERESTS" />

                        <Fade triggerOnce delay={100} >
                            <section className="bg-light border-radius-25 p-4 mt-3" aria-labelledby="about-cv-heading">
                                <h2 id="about-cv-heading" className="fs-25 mb-4 text-red">
                                    <span className="border-bottom black pb-1 fw-700">DOWNLOAD MY CV</span>
                                </h2>
                                <p className="fw-600">
                                    <a
                                        href="/SeroujKhanjihanian-resume.pdf"
                                        download
                                        className="link_red"
                                        aria-label="Download Serouj Khanjihanian CV in PDF format"
                                    >
                                        Download Serouj Khanjihanian CV (PDF)
                                    </a>
                                </p>
                            </section>
                        </Fade>

                        
                    </section>
                </div>
            </section>
        </section>

    )
}

export default About;
